import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControl } from '@shared/modules/dynamic-forms/dynamyc-form.d.model';

@Component({
  selector: 'app-dynamic-field',
  templateUrl: './dynamic-field.component.html',
  styleUrls: ['./dynamic-field.component.scss']
})
export class DynamicFieldComponent {

  @Input()
  public field: DynamicFormControl<string | boolean>;

  @Input()
  public form: FormGroup;

  get isRequired(): boolean {
    return this.form.controls[this.field.key].hasError('required');
  }

  get hasRequiredAttribute(): boolean {
    const errors = this.form.controls[this.field.key].errors;
    return errors && errors.required;
  }
}
